document.addEventListener('DOMContentLoaded', function () {
    const articlesSearchModal = document.querySelector(".articles-search__modal");
    const articlesSearchModalWrapper = document.querySelector(".articles-search__wrapper");
    const openArticlesModalButton = document.querySelector(".articles-search__open-modal-button");
    const closeArticlesModalButton = document.querySelector(".articles-search__close");
    const clearArticlesSearchForm = document.querySelector(".articles-search__input__clear");
    const articlesSearchInput = document.querySelector(".articles-search__input__form");
    const searchResults = document.querySelector(".articles-search__result");

    if (!articlesSearchModal ||
        !articlesSearchModalWrapper ||
        !openArticlesModalButton ||
        !closeArticlesModalButton ||
        !clearArticlesSearchForm ||
        !articlesSearchInput ||
        !searchResults) {
        return;
    }
    function openArticlesSearchModal() {
        articlesSearchModalWrapper.classList.remove("hide");
        requestAnimationFrame(() => {
            articlesSearchModalWrapper.classList.add("articles-search__wrapper_active");
            articlesSearchInput.focus();
        });
    }
    function closeArticlesSearchModal() {
        articlesSearchModalWrapper.classList.remove("articles-search__wrapper_active");
        const onTransitionEnd = (e) => {
            if (e.target === articlesSearchModalWrapper) {
                articlesSearchModalWrapper.classList.add("hide");
                articlesSearchModalWrapper.removeEventListener("transitionend", onTransitionEnd);
            }
        };

        articlesSearchModalWrapper.addEventListener("transitionend", onTransitionEnd);
    }

    openArticlesModalButton.addEventListener("click", openArticlesSearchModal);
    closeArticlesModalButton.addEventListener("click", closeArticlesSearchModal);
    articlesSearchModalWrapper.addEventListener("click", (e) => {
        if (!articlesSearchModal.contains(e.target)) {
            closeArticlesSearchModal();
        }
    });
    clearArticlesSearchForm?.addEventListener("click", () => {
        articlesSearchInput.value = "";
        searchResults.innerHTML = '';
        articlesSearchInput.focus();
    });

    function debounce(func, delay) {
        let timeout;

        return function (...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), delay);
        };
    }

    async function searchArticles(query) {
        if (!query.trim()) return;

        try {
            const response = await fetch('/articles/search?search_request=' + encodeURIComponent(query), {
                method: 'GET',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                }
            });

            const data = await response.json();

            searchResults.innerHTML = data.html;

        } catch (error) {
            console.error('Search error:', error);
        }
    }

    const debouncedSearch = debounce(searchArticles, 500);

    articlesSearchInput.addEventListener('input', function (e) {
        if (articlesSearchInput.value === "") {
            searchResults.innerHTML = '';
        } else {
            debouncedSearch(e.target.value);
        }
    });
});


